<template>
  <BbBtn class="edit_button" size="small" type="secondary" is-icon-button>
    <BbIcon size="small" name="edit" />
  </BbBtn>
</template>

<script>
import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
};
</script>

<style lang="scss" scoped>
.edit_button {
  pointer-events: auto;
  display: inline-flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  border: 1px solid #cecdcc;
  background: $bb-neutral-0;
  flex: auto;

  :deep(.v-btn__content) {
    gap: $bb-spacing-1;
  }
}
</style>
